import { useState } from "react";
export default function LoginForm({ onSubmit, loading }) {
  const [id, setId] = useState("");
  const [password, setPassword] = useState("");
  return (
    <div className="login">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit({ id, password });
        }}
        className="loginform"
      >
        <div id="content_title">
          <h2>로그인</h2>
        </div>
        <p>아이디</p>
        <input className="input_id" placeholder="아이디 입력" value={id} onChange={(e) => setId(e.target.value)} />
        <p>비밀번호</p>
        <input className="input_pw" type="password" placeholder="비밀번호 입력" value={password} onChange={(e) => setPassword(e.target.value)} />
        <button className="loginsubmit" disabled={loading}>
          {loading ? "로그인 중…" : "로그인"}
        </button>
        <div className="join_link">
          <a href="/signup">회원가입</a>
          <span> | </span>
          <a href="/find-password">비밀번호 변경</a>
        </div>
      </form>
    </div>
  );
}
